
import React, { Component } from 'react';
import { Anchor, Box, Heading, Image } from 'grommet';

import BackLink from './BackLink';
import Page from './Page';
import OdrudaList from './OdrudaList';
import ObjectList from './ObjectList';

const RODOKMEN_URL = 'assets/rodokmen.jpg';
const RODOKMEN_PREVIEW_URL = 'assets/rodokmen_preview.jpg';

class OdrudaListPage extends Component {

    componentDidMount() {
        if (!this.props.odrudaList.initialized) {
            this.props.getOdrudaList();
        }
    }

    handleFilterChange = (attributeId, attributeValue) => {
        this.props.setFilter(attributeId, attributeValue);
    }

    render() {
        return (
            <Page>
                <Heading level={1} color="titleColor">Seznam odrůd</Heading>
                <ObjectList objectList={this.props.odrudaList}>
                    <OdrudaList
                        odrudaList={this.props.filteredOdrudaList}
                        odrudaFilter={this.props.odrudaFilter}
                        onFilterChange={this.handleFilterChange}
                    />
                </ObjectList>

                <Box align="center" pad={{top: '16px'}}>
                    <Image fit="contain" src={RODOKMEN_PREVIEW_URL} />
                    <Anchor href={RODOKMEN_URL} label="Otevřít v plném rozlišení" target="link" />
                </Box>

                <BackLink link="/" title="Zpět na úvod"/>
            </Page>
        );
    }
}

export default OdrudaListPage;
